import { collection, deleteDoc, doc, getDocs } from "firebase/firestore";
import { db } from "shared/api/firebase";

export const deletePage = async (brandId: string, pageId?: string) => {
  if (!pageId) {
    console.error("No page ID provided to delete page");
    return;
  }

  try {
    const pageRef = doc(db, `brands/${brandId}/pages`, pageId);
    const modulesRef = collection(pageRef, "modules");

    const modulesSnapshot = await getDocs(modulesRef);

    const moduleDeletionPromises = modulesSnapshot.docs.map((docSnapshot) =>
      deleteDoc(docSnapshot.ref),
    );

    await Promise.all(moduleDeletionPromises);

    await deleteDoc(pageRef);
  } catch (e) {
    console.error("Error occurred when deleting page", e);
  }
};
